
import { Vue } from "vue-property-decorator";

import headerView from "./page/Header.vue";
import footerView from "./page/Footer.vue";

/* tslint:disable:no-console */
declare let apigClientFactory: any;

export default Vue.extend({
  name: "check",
  components: {
    headerView,
    footerView
  },

  data: () => {
    return {
      encode: "",
      message: "",
      isWrongLink: false
    };
  },

  methods: {
    featchValidity() {
      const params = {
        // This is where any header, path, or querystring request params go.
      };
      const body = {
        // This is where you define the body of the request
        encode: this.encode
      };
      const additionalParams = {};
      const apigClient = apigClientFactory.newClient();
      apigClient
        .apiV1IdentityValidatePost(params, body, additionalParams)
        .then((response: any) => {
          // console.log("response", response)
          this.$router.push("/login");
        })
        .catch((error: any) => {
          // console.log("error", error)
          if (error.data.message === "Expired Link") {
            this.isWrongLink = true;
            this.message = "Mohon Maaf Link Anda Sudah Kadaluwarsa";
          } else if (error.data.message === "otp not created") {
            this.isWrongLink = true;
            this.message =
              " Mohon maaf, kode OTP yang Anda masukan tidak valid. Untuk informasi lebih lanjut, silakan hubungi customer service kami di 021-50995121.  Terimakasih ";
          } else if (error.data.message === "otp max created") {
            this.isWrongLink = true;
            this.message =
              " Mohon maaf, kode OTP yang Anda masukan tidak valid. Untuk informasi lebih lanjut, silakan hubungi customer service kami di 021-50995121. Terimakasih ";
          } else if (error.data.statusCode === 401) {
            this.isWrongLink = true;
            let message = "";
            if (error.data.message === "F") {
              message =
                "Terimakasih telah mengisi. Form Anda sedang diproses info lebih lanjut, silakan hubungi 021-50995121";
            } else {
              message =
                "Terimakasih telah mengisi. Form Anda sedang diproses info lebih lanjut, silakan hubungi 021-50995121";
            }
            this.message = message;
          } else {
            this.isWrongLink = true;
            this.message = "Mohon Maaf Link Yang Digunakan Sudah Tidak Valid ";
          }
        });
    }
  },

  mounted() {
    const { params } = this.$route;
    // console.log('params', params.pathMatch.replace("/", ""));
    if (params) {
      let paramsPatch = params.pathMatch.replace("/", "");
      const encode = paramsPatch;
      if (encode !== "*") {
        this.$store.commit("SET_ENCODE", encode);
        this.$store.commit("SET_IS_LOGIN", true);
      }

      // console.log("encode", this.$store.getters.getEncode())
      this.encode = encode;
      this.featchValidity();
    }
  }
});
